import { getLang } from '@/helpers/getLang'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


export type FooterBranch = {
    id: number,
    title: string,
    desc: string,
    address: string,
    email: string,
    phone: string,
    link: string,
    city: string,
    coors: string
}


export const footerApi = createApi({
    reducerPath: 'footerApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api'
    }),
    endpoints: builder => ({
        getAllBranches: builder.query<FooterBranch[], void>({
            query: () => ({ url: `/branches?lang=${getLang()}` })
        }),
        getAllProductions: builder.query<FooterBranch[], void>({
            query: ()=>({ url: `/productions?lang=${getLang()}` })
        })
    })
})

export const { useGetAllBranchesQuery, useGetAllProductionsQuery } = footerApi